import axios from '@/utils/axios'
import { getUrlBaseV2 } from '@/utils/index'

const getBaseUrl = (channelId, attendanceId) =>
    `${getUrlBaseV2()}/channels/${channelId}/omnivoip/${attendanceId}`

export const telephonyOmnichannelService = {
    /**
     * @param {number|string} channelId
     * @param {number|string} attendanceId
     * @param {string} callId
     */
    async acceptCall(channelId, attendanceId, callId) {
        const response = await axios.post(`${getBaseUrl(channelId, attendanceId)}/accept-call`, { call_id: callId })
        return response.data
    },

    /**
     * @param {number|string} channelId
     * @param {number|string} attendanceId
     * @param {string} callId
     */
    async rejectCall(channelId, attendanceId, callId) {
        const response = await axios.post(`${getBaseUrl(channelId, attendanceId)}/reject-call`, { call_id: callId })
        return response.data
    },

    /**
     * @param {number|string} channelId
     * @param {number|string} attendanceId
     * @param {string} callId
     */
    async endCall(channelId, attendanceId, callId) {
        const response = await axios.post(`${getBaseUrl(channelId, attendanceId)}/end-call`, { call_id: callId })
        return response.data
    },

    /**
     * @param {number|string} channelId
     * @param {number|string} attendanceId
     * @param {string} phoneNumber
     */
    async makeCall(channelId, attendanceId, phoneNumber) {
        const response = await axios.post(`${getBaseUrl(channelId, attendanceId)}/make-call`, { phone_number: phoneNumber })
        return response.data
    },
}

export default telephonyOmnichannelService
